import { render } from "./WikipediaItem.vue?vue&type=template&id=a72c2050&scoped=true"
import script from "./WikipediaItem.vue?vue&type=script&lang=js"
export * from "./WikipediaItem.vue?vue&type=script&lang=js"

import "./WikipediaItem.vue?vue&type=style&index=0&id=a72c2050&scoped=true&lang=css"
import "./WikipediaItem.vue?vue&type=style&index=1&id=a72c2050&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a72c2050"]])

export default __exports__